<template>
    <b-modal v-model="show" :title="'Қурилиш материаллари'" :no-close-on-esc="true"
             :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Бино тури <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="dictionaryData.data.buildingSectionType"
                                :class="{invalid : $v.dictionaryData.data.buildingSectionType.$error}"
                                placeholder="Танланг...">
                            <option value=""></option>
                            <option :value="option" v-for="option in buildingSectionTypes" :key="option.code">{{option.name}}</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.buildingSectionType.$error">Бино тури</div>
                    </div>
                    <div class="form-group">
                        <label>Қаватлилиги <span class="red">*</span></label>
                        <treeselect class="form-control"
                                    v-model="dictionaryData.data.floors"
                                    placeholder="Танланг..."
                                    :multiple="true"
                                    :options="floors"
                                    value-format="object"/>
                        <div class="red" v-if="$v.dictionaryData.data.floors.$error">Қаватлилиги</div>
                    </div>
                    <div class="form-group">
                        <label>Девор тури <span class="red">*</span></label>
                        <v-select v-model="dictionaryData.data.wallType" label="name"
                                  :options="wallTypes"
                                  :filterable="false"
                                  :class="{invalid : $v.dictionaryData.data.wallType.$error}"
                                  @search:focus="onConstructiveElementFocus"
                        >
                            <template slot="option" slot-scope="option" v-if="option && option.name">
                                <div v-html="option.name"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.wallType.$error">Девор тури</div>
                    </div>
                    <div class="form-group">
                        <label>Қиймати <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.coeficient"
                                       :precision="2"
                                       :class="{invalid : $v.dictionaryData.data.coeficient.$error}"
                                       placeholder="Киритинг..."></numeric-input>
                    </div>
                    <div class="red" v-if="$v.dictionaryData.data.coeficient.$error">Қиймати</div>
                </div>
            </div>

        </div>

        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_MATERIALS_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask';
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import {clone} from '@/shared/utils';
    import {required, minValue, minLength} from 'vuelidate/lib/validators';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: "BuildingMaterialsAddView",
        components: {
            Treeselect,
            'b-modal': bModal,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                dictionaryData: {
                    dictionaryType: 'BUILDING_MATERIALS',
                    data: {
                        buildingSectionType: {},
                        floors: [],
                        wallType: {},
                        coeficient: 0
                    }
                },
                buildingSectionTypes: [
                    {"code": "ResidentialMultiStorey", name: "Кўпқаватли"},
                    {"code": "ResidentialIndividual", name: "Якка тартибдаги"}
                ],
                floors: [
                    {"id": "1", label: "1 қаватли"},
                    {"id": "2", label: "2 қаватли"},
                    {"id": "3", label: "3 қаватли"},
                    {"id": "4", label: "4 қаватли"},
                    {"id": "5", label: "5 қаватли"},
                    {"id": "6", label: "6 қаватли"},
                    {"id": "7", label: "7 қаватли"},
                    {"id": "8", label: "8 қаватли"},
                    {"id": "9", label: "9 қаватли"},
                    {"id": "10", label: "10 қаватли"},
                    {"id": "11", label: "11 қаватли"},
                    {"id": "12", label: "12 қаватли"},
                    {"id": "13", label: "13 қаватли"},
                    {"id": "14", label: "14 қаватли"},
                    {"id": "15", label: "15 қаватли"},
                    {"id": "16", label: "16 қаватли"},
                    {"id": "17", label: "17 қаватли"},
                    {"id": "18", label: "18 қаватли"}
                ],
                wallTypes: []
            }
        },
        validations: {
            dictionaryData: {
                data: {
                    buildingSectionType: {
                        required: required
                    },
                    floors: {
                        required: required,
                        minLength: minLength(1)
                    },
                    wallType: {
                        required: required
                    },
                    coeficient: {
                        required: required,
                        minValue: minValue(0.01)
                    }
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.dictionaryData.data.wallType.data = null;
                this.$http.post('dictionary/saveBuildingMaterials', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('buildingMaterialsChanged', response);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.message,
                                type: 'warning'
                            });
                        }
                    });
            },
            onConstructiveElementFocus() {
                const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
                this.$http.get(url)
                    .then(res => {
                        this.wallTypes = res.data.map(wall => ({code: wall.code, name: wall.displayName}));
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showBuildingMaterialsAdd', (data) => {
                if (data) {
                    this.dictionaryData.id = data.id;
                    this.dictionaryData.data = clone(data.data);
                } else {
                    this.dictionaryData = {
                        data: {
                            coeficient: 0
                        }
                    }
                }

                this.show = true;
            });
        }
    }
</script>
<style scoped>

</style>